<template>
  <div
    v-if="event !== undefined"
    :style="event.branding ? { background: event.branding.tertiaryColor } : { background: '#FFFFFF' }"
  >
    <div v-if="!onboarded" class="card card-overlay">
      <b-steps v-model="onboardStep" type="is-primary" :has-navigation="false">
        <b-step-item :label="$t('welcome')" :clickable="false">
          <h1 class="title is-3 mb-1 mt-2">
            <span v-if="event.name">{{ event.name }}</span>
            <b-skeleton v-else height="36px" />
          </h1>
          <div>
            <b-field :label="$t('nickname')">
              <b-input id="name-input" v-model="username" :lazy="true" />
            </b-field>
            <b-button type="is-primary" class="mr-2" @click="startJoin">
              {{ $t("joinViewerLivestream") }}
            </b-button>
          </div>
        </b-step-item>
      </b-steps>
    </div>
    <EventChat
      v-if="onboarded"
      ref="eventChat"
      :event="event"
      :participants="participants"
      :translators="translators"
      :big.sync="big"
    />

    <div v-if="onboarded" class="top-view-container" :class="[big ? 'small' : '']">
      <div class="qonda-watermark">
        <img src="/assets/logos/1c-negative.svg" />
      </div>
      <LiveStream />
    </div>
  </div>
</template>

<script>
// import { auth, db, functions, FieldValue } from "@/firebase";
import { auth, db } from "@/firebase";
// import Conference from "./Conference.vue";
import EventChat from "../EventChat.vue";
import LiveStream from "../LiveStream.vue";
// import RoomClient from "../../mediasoup-client/RoomClient.js";
// import deviceInfo from "../../mediasoup-client/deviceInfo.js";
// import { mapState } from "vuex";

export default {
  name: "ViewerLiveOverlay",
  components: {
    EventChat,
    LiveStream,
  },
  props: {},
  data() {
    return {
      onboardStep: 0,
      username: "",
      onboarded: false,
      big: false,
      event: undefined,
      firestoreParticipants: [],
      firestoreTranslators: [],
    };
  },
  computed: {
    participants() {
      let obj = {};
      for (let participant of this.firestoreParticipants) {
        obj[participant.id] = participant;
      }
      //console.log("participants", obj);
      return obj;
    },
    translators() {
      let obj = {};
      for (let translator of this.firestoreTranslators) {
        obj[translator.id] = translator;
      }
      return obj;
    },
    /**
     * Computed property returns participants collection from firebase db.
     */
    participantsCollection() {
      return db.collection(
        `organizations/${this.$route.params.organizationId}/events/${this.$route.params.eventId}/participants`,
      );
    },
    /**
     * Computed property returns translators collection from firebase db.
     */
    translatorsCollection() {
      return db.collection(
        `organizations/${this.$route.params.organizationId}/events/${this.$route.params.eventId}/translators`,
      );
    },
  },
  async created() {
    if (this.$store.getters.getCurrentUser == null) {
      try {
        await auth.signInAnonymously();
      } catch (error) {
        console.error("Error in ViewerLiveStream.vue created hook", error);
      }
    }

    try {
      var deviceLang = navigator.language || navigator.userLanguage;
      if (deviceLang && this.$i18n.availableLocales.includes(deviceLang.substr(0, 2))) {
        this.$i18n.locale = deviceLang.substr(0, 2);
      } else {
        this.$i18n.locale = "en";
      }
    } catch (error) {
      console.warn(error);
    }
  },
  // beforeMount() {
  //   window.addEventListener("beforeunload", async () => {
  //     await this.participantsCollection
  //       .doc(this.$store.getters.getCurrentUser.uid)
  //       .delete();
  //   });
  // },
  methods: {
    async startJoin() {
      this.onboarded = true;

      let mediasoupId = String(Math.random() * 10000);

      try {
        await this.participantsCollection.doc(this.$store.getters.getCurrentUser.uid).set(
          {
            name: this.username,
            mediasoupId: mediasoupId,
          },
          { merge: true },
        );
      } catch (error) {
        console.error("Error in ViewerLiveStream.vue startJoin(): ", error);
      }
      this.$store.commit("mediasoup/set_mediasoupId", mediasoupId);
      this.$store.commit("mediasoup/set_displayName", this.username);
      this.$store.commit("mediasoup/set_viewerLive", true);
    },
  },
  firestore() {
    return {
      firestoreParticipants: this.participantsCollection,
      firestoreTranslators: this.translatorsCollection,
      event: db.doc(`organizations/${this.$route.params.organizationId}/events/${this.$route.params.eventId}`),
    };
  },
};
</script>

<style scoped>
.card.card-overlay {
  position: fixed;
  max-width: 750px;
  width: 100%;
  padding: 2em 1em;
  border-radius: 16px;
  margin-left: 50%;
  margin-top: calc(50vh - 60px);
  transform: translate(-50%, -50%);
  z-index: 60000;
}

.top-view-container {
  display: block;
  height: calc(100vh - 0px);
  position: relative;
  /* width: calc(80% - 1rem); */
  width: calc(100% - 64px - 1rem);
  justify-content: center;
  align-content: center;
}

.top-view-container.small {
  width: calc(80% - 1rem);
}

.top-view-container.translator-view {
  height: calc(100vh - 15rem);
}

.chat-container.card.sidebar {
  min-width: 20%;
  height: 100vh;
  position: fixed;
  right: 0px;
}

.chat-container.card.sidebar.translator {
  height: calc(100vh - 15rem);
}

.qonda-watermark {
  width: 100px;
  height: auto;
  z-index: 99999;
  opacity: 0.5;
  margin: 2rem;
  position: absolute;
  left: 0;
  bottom: 0;
}
</style>
